import { IDashboardHomeCardMetricKey } from '~/src/dash/api/dashboards/home';
import { ValueType } from '~/src/dash/components/tables/common';

export const nonBidFloorKeysForChart: string[] = [
  'date',
  'controlBidFloorKey',
  'weightedAvgControlBidFloor',
  'weightedAvgSmartBidFloor',
];

export interface IStackedChartData {
  date: string;
  controlBidFloorKey: string; // control bid floor key, can be "8.50_4" or "control"
  weightedAvgControlBidFloor: number; // for aggregated graph by bid floor type (control vs smart)
  weightedAvgSmartBidFloor: number; // for aggregated graph by bid floor type (control vs smart)
  [key: string]: string | number; // bid floor -> metric value, ex: {"8.50": 2000, "9.00": 3000, ...}
}

export interface ISmartFloorsLiveAdaptiveConfig {
  defaultState: {
    selectedMetricKey: IDashboardHomeCardMetricKey;
  };
  metrics: Partial<
    Record<
      IDashboardHomeCardMetricKey,
      {
        key: IDashboardHomeCardMetricKey;
        label: string;
        valueType: ValueType;
      }
    >
  >;
}

export const smartFloorsLiveAdaptiveConfig: ISmartFloorsLiveAdaptiveConfig = {
  defaultState: {
    selectedMetricKey: 'BidRequestPercentage',
  },

  metrics: {
    BidRequests: {
      key: 'BidRequests',
      label: 'Bid Requests',
      valueType: 'integer',
    },
    BidRequestPercentage: {
      key: 'BidRequestPercentage',
      label: 'Bid Request Percentage',
      valueType: 'percent',
    },
    BidResponses: {
      key: 'BidResponses',
      label: 'Bid Responses',
      valueType: 'integer',
    },
    CPM: {
      key: 'CPM',
      label: 'CPM',
      valueType: 'currency_rate',
    },
    EstimatedRevenue: {
      key: 'EstimatedRevenue',
      label: 'Estimated Revenue',
      valueType: 'currency',
    },
    WinningBids: {
      key: 'WinningBids',
      label: 'Winning Bids',
      valueType: 'integer',
    },
  },
};
